import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { attrs: { flat: "" } },
    [
      _c(
        VCardTitle,
        { staticClass: "subtitle-1 pa-0 ma-0" },
        [
          _c("span", [_vm._v(_vm._s(_vm.value.titulo))]),
          _c(VSwitch, {
            staticClass: "ml-4",
            attrs: { color: "secondary", dense: "" },
            model: {
              value: _vm.value.habilitado,
              callback: function ($$v) {
                _vm.$set(_vm.value, "habilitado", $$v)
              },
              expression: "value.habilitado",
            },
          }),
        ],
        1
      ),
      _c(
        VCardText,
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value.habilitado,
              expression: "value.habilitado",
            },
          ],
          staticClass: "pa-0 ma-0",
        },
        [
          _c(
            VRadioGroup,
            {
              attrs: { row: _vm.value.horizontal, dense: "" },
              model: {
                value: _vm.value.opcao,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "opcao", $$v)
                },
                expression: "value.opcao",
              },
            },
            _vm._l(_vm.value.opcoes, function (opcao) {
              return _c(VRadio, {
                key: opcao.nome,
                attrs: { value: opcao.valor, label: opcao.nome },
              })
            }),
            1
          ),
          _vm._t("children"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }